import {
  RecommendationsSettingsState,
  RecommendationsState,
} from '../../types/Recommendations.js';
import { RootState } from '../reducer/index.js';

export const getNewRecommendationsStatusState = (state: RootState): boolean =>
  !!(state.recommendations as RecommendationsState).hasNew;

export const getRecommendationsSettingsState = (
  state: RootState,
): RecommendationsSettingsState => state.recommendationsSettings;
